import { Box } from "@chakra-ui/react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import RegistrationFlow from "./components/RegistrationFlow";
import TopMenu from "./components/TopMenu";
import { RegistrationProvider } from "./context/Registration";
import axios from "axios";
import { SWRConfig } from "swr";
import { Provider, ErrorBoundary } from "@rollbar/react";

import ExpiredLinkPage from "./pages/static/ExpiredLinkPage";
import EmailVerifiedPage from "./pages/static/EmailVerifiedPage";

import { BookLayout } from "./layouts/BookLayout";
import { GuardianInfoPage } from "./pages/book/GuardianInfoPage";
import { ChildInfoPage } from "./pages/book/ChildInfoPage";
import { BookingProvider } from "./context/BookingContext";
import { SelectClassPage } from "./pages/book/SelectClassPage";
import { SelectSlotPage } from "./pages/book/SelectSlotPage";
import { BookConfirmPage } from "./pages/book/BookConfirmPage";
import { BookSuccessPage } from "./pages/book/BookSuccessPage";
import { LoginPage } from "./pages/LoginPage";

const fetcher = (url: string) => axios.get(url).then((res) => res.data);

// TODO: better place to set these
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken";

const rollbarConfig = {
  accessToken: process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN,
  environment: process.env.REACT_APP_ROLLBAR_ENVIRONMENT,
  server: {
    root: process.env.REACT_APP_PUBLIC_URL,
  },
};

function App() {
  return (
    <Provider config={rollbarConfig}>
      {/* ErrorBoundary catches all React errors in the tree below and logs them to Rollbar */}
      <ErrorBoundary>
        <SWRConfig value={{ fetcher }}>
          <Router>
            <Switch>
              <Route path="/login">
                <LoginPage />
              </Route>

              <Box>
                <TopMenu />
                <BookingProvider>
                  <Route exact path="/book/success">
                    <BookSuccessPage />
                  </Route>
                  <Route exact path="/book">
                    <BookLayout>
                      <Redirect to="/book/guardian-info" />
                    </BookLayout>
                  </Route>
                  <Route path="/book/guardian-info">
                    <BookLayout>
                      <GuardianInfoPage />
                    </BookLayout>
                  </Route>
                  <Route path="/book/child-info">
                    <BookLayout>
                      <ChildInfoPage />
                    </BookLayout>
                  </Route>
                  <Route path="/book/select-class">
                    <BookLayout>
                      <SelectClassPage />
                    </BookLayout>
                  </Route>
                  <Route path="/book/select-slot">
                    <BookLayout>
                      <SelectSlotPage />
                    </BookLayout>
                  </Route>
                  <Route path="/book/confirm">
                    <BookLayout>
                      <BookConfirmPage />
                    </BookLayout>
                  </Route>
                </BookingProvider>

                <RegistrationProvider>
                  <Route path="/" exact>
                    <Redirect to="/register" />
                  </Route>
                  <Route path="/email-verified">
                    <EmailVerifiedPage />
                  </Route>
                  <Route path="/expired-link">
                    <ExpiredLinkPage />
                  </Route>
                  <Route path="/users">Users page.</Route>

                  <Route path="/register">
                    <RegistrationFlow />
                  </Route>
                </RegistrationProvider>
              </Box>
            </Switch>
          </Router>
        </SWRConfig>
      </ErrorBoundary>
    </Provider>
  );
}

export default App;
